import { HStack, IconButton } from '@chakra-ui/react';
import type { SearchBarProps } from '@time-line/components/common';
import { SearchBar } from '@time-line/components/common';
import { ArrowRight, MagnifyingGlass } from '@time-line/components/icons';
import { useEffect, useRef } from 'react';

interface SearchHeaderProps {
  inputProps: SearchBarProps['inputProps'];
  isActive: boolean;
  onBack?: () => void;
}

export function SearchHeader({
  inputProps,
  isActive,
  onBack,
}: SearchHeaderProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isActive && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isActive]);

  return (
    <HStack
      gap="3xs"
      borderBottom={isActive ? '1px solid' : 'none'}
      borderColor="blackAlpha.250"
    >
      {isActive ? (
        <IconButton
          aria-label="Close"
          variant="link"
          icon={<ArrowRight boxSize="sm" transform="rotate(180deg)" />}
          onClick={onBack}
        />
      ) : (
        <MagnifyingGlass boxSize="sm" />
      )}
      <SearchBar
        size="lg"
        variant="unstyled"
        displayClearAsText
        hideSearchIcon
        placeholder="Search"
        inputProps={{
          ...inputProps,
          ref: inputRef,
          _focusVisible: { boxShadow: 'outline' },
        }}
      />
    </HStack>
  );
}
